var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "client-single" }, [
    _c("div", { staticClass: "m-content" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-lg-7" }, [
          _c("div", { staticClass: "m-portlet  m-portlet--full-height " }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "m-portlet__body" },
              [_c("timeline", { attrs: { "timeline-arr": _vm.timelineArr } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-lg-5" },
          [
            _c("div", { staticClass: "m-portlet" }, [
              _c("div", { staticClass: "m-portlet__head" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "m-portlet__head-tools" }, [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm",
                      staticStyle: {
                        "min-width": "220px",
                        "justify-content": "end"
                      },
                      attrs: { role: "tablist" }
                    },
                    [
                      _c("li", { staticClass: "nav-item m-tabs__item" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: {
                              type: "button",
                              disabled:
                                _vm.isSyncingHubspotData ||
                                !(
                                  _vm.client.user &&
                                  _vm.client.user.hubspot_id > 0
                                )
                            },
                            on: {
                              click: function($event) {
                                return _vm.syncHubspotData()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                            Sync\n                                        "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "nav-item m-tabs__item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link m-tabs__link btn-hubspot",
                            attrs: {
                              "data-toggle": "tab",
                              href:
                                "https://app-eu1.hubspot.com/contacts/25794910/company/" +
                                _vm.client.hubspot_id,
                              role: "tab"
                            }
                          },
                          [
                            _vm._v(
                              "\n                                            Zu Hubspot\n                                        "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "m-portlet__body" }, [
                _c("div", { staticClass: "tab-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "tab-pane active",
                      attrs: {
                        id: "m_widget5_tab1_content_client",
                        "aria-expanded": "true"
                      }
                    },
                    [
                      _c("div", [
                        _c("div", { staticClass: "m-portlet__padding-x" }, [
                          _c("div", {}, [
                            _c("div", {}, [
                              _c("div", [
                                _c("div", [
                                  _c("div", [
                                    _vm._v(
                                      "\n                                                                " +
                                        _vm._s(_vm.client.company) +
                                        "\n                                                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.client.company))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {}, [_vm._v("KONTAKT:")]),
                                  _vm._v(" "),
                                  _c("div", {}, [
                                    _vm._v(
                                      _vm._s(_vm.client.user.salutation) +
                                        " " +
                                        _vm._s(_vm.client.user.pre_name) +
                                        " " +
                                        _vm._s(_vm.client.user.name)
                                    )
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _c("div", { staticClass: "m-demo-icon" }, [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-demo-icon__class" }, [
                              _vm._v(_vm._s(_vm.client.main_mail))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "m-demo-icon" }, [
                            _vm._m(3),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-demo-icon__class" }, [
                              _vm._v(_vm._s(_vm.client.phone)),
                              _vm.client.mobile != ""
                                ? _c("span", [
                                    _c("br"),
                                    _vm._v(_vm._s(_vm.client.mobile))
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6" }, [
                          _c("div", { staticClass: "m-demo-icon" }, [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-demo-icon__class" }, [
                              _vm._v(_vm._s(_vm.client.street)),
                              _c("br"),
                              _vm._v(_vm._s(_vm.client.additional_1)),
                              _vm.client.additional_1 != ""
                                ? _c("br")
                                : _vm._e(),
                              _vm._v(_vm._s(_vm.client.additional_2)),
                              _vm.client.additional_2 != ""
                                ? _c("br")
                                : _vm._e(),
                              _vm._v(
                                _vm._s(_vm.client.zip) +
                                  " " +
                                  _vm._s(_vm.client.city)
                              )
                            ])
                          ])
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            false
              ? _c(
                  "div",
                  {
                    staticClass:
                      "m-portlet m-portlet--accent m-portlet--head-solid-bg m-portlet--head-sm",
                    attrs: { "m-portlet": "true", id: "m_portlet_tools_new" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "m-portlet__head",
                        on: {
                          click: function($event) {
                            return _vm.addNewProjectTemplate()
                          }
                        }
                      },
                      [_vm._m(5), _vm._v(" "), _vm._m(6)]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.projectTemplates, function(
              projectTemplate,
              projectTemplateKey
            ) {
              return _c(
                "div",
                {
                  staticClass:
                    "m-portlet m-portlet--brand m-portlet--head-solid-bg m-portlet--head-sm",
                  attrs: { "m-portlet": "true", id: "m_portlet_tools_1" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "m-portlet__head",
                      on: {
                        click: function($event) {
                          projectTemplate.editClientDataToggle = !projectTemplate.editClientDataToggle
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "m-portlet__head-caption" }, [
                        _c("div", { staticClass: "m-portlet__head-title" }, [
                          _vm._m(7, true),
                          _vm._v(" "),
                          projectTemplate.id == 0
                            ? _c(
                                "h3",
                                { staticClass: "m-portlet__head-text" },
                                [
                                  _vm._v(
                                    "\n                                        Projekt Vorlage\n                                    "
                                  )
                                ]
                              )
                            : _c(
                                "h3",
                                { staticClass: "m-portlet__head-text" },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(projectTemplate.name) +
                                      "\n                                    "
                                  )
                                ]
                              )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__head-tools" }, [
                        _c("ul", { staticClass: "m-portlet__nav" }, [
                          _c("li", { staticClass: "m-portlet__nav-item" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "m-portlet__nav-link m-portlet__nav-link--icon"
                              },
                              [
                                projectTemplate.editClientDataToggle
                                  ? _c("i", { staticClass: "la la-angle-up" })
                                  : _c("i", { staticClass: "la la-angle-down" })
                              ]
                            )
                          ])
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "m-portlet__body",
                      class: { "d-none": !projectTemplate.editClientDataToggle }
                    },
                    [
                      _c(
                        "form",
                        {
                          staticClass:
                            "m-form m-form--fit m-form--label-align-right",
                          attrs: { method: "POST" }
                        },
                        [
                          _c("div", { staticClass: "m-portlet__body" }, [
                            _c(
                              "div",
                              { staticClass: "form-group m-form__group row" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-3 col-form-label",
                                    attrs: { for: "projectTemplateName" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            Vorlage Titel\n                                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-9" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: projectTemplate.name,
                                        expression: "projectTemplate.name"
                                      }
                                    ],
                                    staticClass: "form-control m-input",
                                    attrs: {
                                      type: "text",
                                      id: "projectTemplateName",
                                      name: "projectTemplateName"
                                    },
                                    domProps: { value: projectTemplate.name },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          projectTemplate,
                                          "name",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group m-form__group row" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-3 col-form-label",
                                    attrs: { for: "projectTemplateName" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            Format / Auflösung\n                                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-9" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: projectTemplate.scale,
                                        expression: "projectTemplate.scale"
                                      }
                                    ],
                                    staticClass: "form-control m-input",
                                    attrs: {
                                      type: "text",
                                      id: "projectTemplateScale",
                                      name: "projectTemplateScale"
                                    },
                                    domProps: { value: projectTemplate.scale },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          projectTemplate,
                                          "scale",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group m-form__group row" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-3 col-form-label",
                                    attrs: { for: "projectTemplateName" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            Schwierigkeitsgrad\n                                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-9" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: projectTemplate.difficulty,
                                          expression:
                                            "projectTemplate.difficulty"
                                        }
                                      ],
                                      staticClass: "form-control m-input",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            projectTemplate,
                                            "difficulty",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "1" } }, [
                                        _vm._v("sehr einfach")
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "2" } }, [
                                        _vm._v("einfach")
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "3" } }, [
                                        _vm._v("normal")
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "4" } }, [
                                        _vm._v("schwer")
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "5" } }, [
                                        _vm._v("sehr schwer")
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group m-form__group row" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-3 col-form-label",
                                    attrs: { for: "projectTemplateName" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            Kategorie\n                                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-9" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: projectTemplate.category_id,
                                          expression:
                                            "projectTemplate.category_id"
                                        }
                                      ],
                                      staticClass: "form-control m-input",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.$set(
                                            projectTemplate,
                                            "category_id",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("option", { attrs: { value: "0" } }, [
                                        _vm._v("Bitte wählen")
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.categoriesArr, function(
                                        category,
                                        key
                                      ) {
                                        return _c(
                                          "option",
                                          { domProps: { value: key } },
                                          [_vm._v(_vm._s(category))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-group m-form__group row m--margin-top-5"
                              },
                              [
                                _c("div", { staticClass: "col-9 offset-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "m-checkbox-inline" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "m-checkbox m-checkbox--square"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: projectTemplate.jpg,
                                                expression:
                                                  "projectTemplate.jpg"
                                              }
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                projectTemplate.jpg
                                              )
                                                ? _vm._i(
                                                    projectTemplate.jpg,
                                                    null
                                                  ) > -1
                                                : projectTemplate.jpg
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = projectTemplate.jpg,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "jpg",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "jpg",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    projectTemplate,
                                                    "jpg",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            " JPG\n                                                    "
                                          ),
                                          _c("span")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "m-checkbox m-checkbox--square"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: projectTemplate.png,
                                                expression:
                                                  "projectTemplate.png"
                                              }
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                projectTemplate.png
                                              )
                                                ? _vm._i(
                                                    projectTemplate.png,
                                                    null
                                                  ) > -1
                                                : projectTemplate.png
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = projectTemplate.png,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "png",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "png",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    projectTemplate,
                                                    "png",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            " PNG\n                                                    "
                                          ),
                                          _c("span")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "m-checkbox m-checkbox--square"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: projectTemplate.psd,
                                                expression:
                                                  "projectTemplate.psd"
                                              }
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                projectTemplate.psd
                                              )
                                                ? _vm._i(
                                                    projectTemplate.psd,
                                                    null
                                                  ) > -1
                                                : projectTemplate.psd
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = projectTemplate.psd,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "psd",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "psd",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    projectTemplate,
                                                    "psd",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            " PSD\n                                                    "
                                          ),
                                          _c("span")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "m-checkbox m-checkbox--square"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: projectTemplate.tiff,
                                                expression:
                                                  "projectTemplate.tiff"
                                              }
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                projectTemplate.tiff
                                              )
                                                ? _vm._i(
                                                    projectTemplate.tiff,
                                                    null
                                                  ) > -1
                                                : projectTemplate.tiff
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a = projectTemplate.tiff,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "tiff",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "tiff",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    projectTemplate,
                                                    "tiff",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            " TIFF\n                                                    "
                                          ),
                                          _c("span")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "m-checkbox m-checkbox--square"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  projectTemplate.withMirror,
                                                expression:
                                                  "projectTemplate.withMirror"
                                              }
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                projectTemplate.withMirror
                                              )
                                                ? _vm._i(
                                                    projectTemplate.withMirror,
                                                    null
                                                  ) > -1
                                                : projectTemplate.withMirror
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    projectTemplate.withMirror,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "withMirror",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "withMirror",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    projectTemplate,
                                                    "withMirror",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            " Spiegelung\n                                                    "
                                          ),
                                          _c("span")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "m-checkbox m-checkbox--square"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  projectTemplate.withShadow,
                                                expression:
                                                  "projectTemplate.withShadow"
                                              }
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                projectTemplate.withShadow
                                              )
                                                ? _vm._i(
                                                    projectTemplate.withShadow,
                                                    null
                                                  ) > -1
                                                : projectTemplate.withShadow
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    projectTemplate.withShadow,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "withShadow",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        projectTemplate,
                                                        "withShadow",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    projectTemplate,
                                                    "withShadow",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            " Schatten\n                                                    "
                                          ),
                                          _c("span")
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group m-form__group row" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "col-3 col-form-label",
                                    attrs: { for: "projectTemplateName" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            Notiz\n                                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-9" }, [
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: projectTemplate.description,
                                        expression:
                                          "projectTemplate.description"
                                      }
                                    ],
                                    staticClass: "form-control m-input",
                                    attrs: {
                                      rows: "3",
                                      id: "projectTemplateDescription",
                                      name: "projectTemplateDescription"
                                    },
                                    domProps: {
                                      value: projectTemplate.description
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          projectTemplate,
                                          "description",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("table", { staticClass: "table" }, [
                              _vm._m(8, true),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(projectTemplate.taskArr, function(task) {
                                  return _c("tr", [
                                    _c("td", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: task.quantity,
                                            expression: "task.quantity"
                                          }
                                        ],
                                        staticClass: "form-control m-input",
                                        attrs: { type: "text" },
                                        domProps: { value: task.quantity },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              task,
                                              "quantity",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: task.type,
                                              expression: "task.type"
                                            }
                                          ],
                                          staticClass:
                                            "form-control m-input m-input--square",
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                task,
                                                "type",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        _vm._l(_vm.taskTypeArr, function(
                                          taskType,
                                          key
                                        ) {
                                          return _c(
                                            "option",
                                            { domProps: { value: key } },
                                            [_vm._v(_vm._s(taskType))]
                                          )
                                        }),
                                        0
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: task.name,
                                            expression: "task.name"
                                          }
                                        ],
                                        staticClass: "form-control m-input",
                                        attrs: { type: "text" },
                                        domProps: { value: task.name },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              task,
                                              "name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: task.price,
                                            expression: "task.price"
                                          }
                                        ],
                                        staticClass: "form-control m-input",
                                        attrs: { type: "number", step: "0.01" },
                                        domProps: { value: task.price },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              task,
                                              "price",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ])
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex justify-content-end" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-success m-btn m-btn--custom m-btn--bolder m-btn--uppercase",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addNewTask(
                                          projectTemplateKey
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "la la-plus" })]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "m-portlet__foot m-portlet__foot--fit"
                            },
                            [
                              _c("div", { staticClass: "m-form__actions" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.saveProjectTemplate(
                                          projectTemplateKey
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            SPEICHERN\n                                        "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "m-portlet m-portlet--accent m-portlet--head-solid-bg m-portlet--head-sm",
                attrs: { "m-portlet": "true", id: "m_portlet_tools_note" }
              },
              [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "m-portlet__body" }, [
                  _c(
                    "form",
                    {
                      staticClass:
                        "m-form m-form--fit m-form--label-align-right",
                      attrs: { method: "POST" }
                    },
                    [
                      _c(
                        "textarea",
                        {
                          attrs: {
                            id: "js-client-note-summernote",
                            name: "client-note"
                          }
                        },
                        [_vm._v(_vm._s(_vm.client.note))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-brand mt-2",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.saveNote()
                            }
                          }
                        },
                        [_vm._v("Speichern")]
                      )
                    ]
                  )
                ])
              ]
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.statistikData.doneArr && _vm.statistikData.doneArr.projectArr
        ? _c(
            "div",
            { staticClass: "row m-row--col-separator-xl" },
            _vm._l(_vm.statistikData.doneArr.projectArr, function(project) {
              return _c("project-stats", {
                key: project.id,
                staticClass: "col-xl-4",
                attrs: { project: project }
              })
            }),
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v(
              "\n                                        Kunden Verlauf\n                                    "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head-caption" }, [
      _c("div", { staticClass: "m-portlet__head-title" }, [
        _c("h3", { staticClass: "m-portlet__head-text" }, [
          _vm._v(
            "\n                                        Stammdaten\n                                    "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-demo-icon__preview" }, [
      _c("i", { staticClass: "fa fa-at" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-demo-icon__preview" }, [
      _c("i", { staticClass: "fa fa-phone" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-demo-icon__preview" }, [
      _c("i", { staticClass: "fa fa-home" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head-caption" }, [
      _c("div", { staticClass: "m-portlet__head-title" }, [
        _c("span", { staticClass: "m-portlet__head-icon" }, [
          _c("i", { staticClass: "la la-list-ul" })
        ]),
        _vm._v(" "),
        _c("h3", { staticClass: "m-portlet__head-text" }, [
          _vm._v(
            "\n                                        Neue Projekt Vorlage\n                                    "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head-tools" }, [
      _c("ul", { staticClass: "m-portlet__nav" }, [
        _c("li", { staticClass: "m-portlet__nav-item" }, [
          _c(
            "a",
            { staticClass: "m-portlet__nav-link m-portlet__nav-link--icon" },
            [_c("i", { staticClass: "la la-plus" })]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon" }, [
      _c("i", { staticClass: "flaticon-user" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "60" } }, [_vm._v("Anzahl")]),
        _vm._v(" "),
        _c("th", [_vm._v("Typ")]),
        _vm._v(" "),
        _c("th", [_vm._v("Beschreibung")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "100" } }, [_vm._v("Preis")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-portlet__head" }, [
      _c("div", { staticClass: "m-portlet__head-caption" }, [
        _c("div", { staticClass: "m-portlet__head-title" }, [
          _c("span", { staticClass: "m-portlet__head-icon" }, [
            _c("i", { staticClass: "la la-list-ul" })
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "m-portlet__head-text" }, [
            _vm._v(
              "\n                                        Kunden Notiz\n                                    "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-portlet__head-tools" }, [
        _c("ul", { staticClass: "m-portlet__nav" }, [
          _c("li", { staticClass: "m-portlet__nav-item" }, [
            _c(
              "a",
              { staticClass: "m-portlet__nav-link m-portlet__nav-link--icon" },
              [_c("i", { staticClass: "la la-plus" })]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }